function parseLimitMinUnderflow(): string {
  return 'Невозможно понизить лимит ниже дефолтного значения.';
}

export default parseLimitMinUnderflow;
